import React from "react";
import { PatternFormat as NumberFormat } from "react-number-format";
import { Form, Col, Row } from "react-bootstrap";

import CountrySelect, { exists as CountryValid, label as CountryLabel } from "../../select/country";
import StateSelect, { exists as StateValid, label as StateLabel } from "../../select/state";
import CountySelect, { exists as CountyValid } from "../../select/county";
import { deepEqual } from "../../../utils/object";

class Address extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? {
                country: props.meta?.defaults?.country,
                state: props.meta?.defaults?.state
            },
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    getData = () => {
        return this.state.data;
    }

    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data !== this.props.data) {
            this.setState({
                data: this.props.data ?? {
                    country: this.props.meta?.defaults?.country,
                    state: this.props.meta?.defaults?.state
                }
            });
        }
    }

    onChange = (e) => {
        const newData = {
            ...this.state.data,
            [e.target.name]: e.target.value
        };
        
        this.setState({
            data: newData
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    onCountryChange = (e) => {
        if (CountryValid(e.value)) {
            this.onChange({ target: { name: "country", value: e.value } });
        }
    }

    onStateChange = (e) => {
        if (StateValid(e.value)) {
            this.onChange({ target: { name: "state", value: e.value } });
        }
    }

    onCountyChange = (e) => {
        if (CountyValid(this.state.data.state, e.value)) {
            this.onChange({ target: { name: "county", value: e.value } });
        }
    }

    render() {
        return (
            <>
                {this.state.label && (
                    <Row className="g-3">
                        <Col lg="12">
                            <h2 className="small-title">{this.state.label}</h2>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col lg="12">
                        <div className="mb-3 top-label">
                            <Form.Control
                                value={this.state.data.line1 || ""}
                                type="text"
                                name="line1"
                                onChange={this.onChange}
                                readOnly={this.state.locked}
                            />
                            <Form.Label>ADDRESS (Line 1)</Form.Label>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg="12">
                        <div className="mb-3 top-label">
                            <Form.Control
                                value={this.state.data.line2 || ""}
                                type="text"
                                name="line2"
                                onChange={this.onChange}
                                readOnly={this.state.locked}
                            />
                            <Form.Label>ADDRESS (Line 2)</Form.Label>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg="12">
                        <div className="mb-3 top-label">
                            {this.state.locked ? (
                                <Form.Control
                                    type="text"
                                    name="country"
                                    value={CountryLabel(this.state.data.country) || ""}
                                    readOnly={true}
                                />
                            ) : (
                                <CountrySelect
                                    value={this.state.data.country || "US"}
                                    onChange={this.onCountryChange}
                                    placeholder=""
                                    name="country"
                                />
                            )}
                            <Form.Label>COUNTRY</Form.Label>
                        </div>
                    </Col>
                </Row>
                {this.state.data.country === 'US' ? (
                    <Row>
                        <Col lg="4">
                            <div className="mb-3 top-label">
                                <Form.Control
                                    value={this.state.data.city || ""}
                                    type="text"
                                    name="city"
                                    onChange={this.onChange}
                                    readOnly={this.state.locked}
                                />
                                <Form.Label>CITY</Form.Label>
                            </div>
                        </Col>
                        <Col lg="3">
                            <div className="mb-3 top-label">
                                {this.state.locked ? (
                                    <Form.Control
                                        type="text"
                                        name="state"
                                        value={StateLabel(this.state.data.state) || ""}
                                        readOnly={true}
                                    />
                                ) : (
                                    <StateSelect
                                        value={this.state.data.state || ""}
                                        onChange={this.onStateChange}
                                        placeholder=""
                                        name="state"
                                    />
                                )}
                                <Form.Label>STATE</Form.Label>
                            </div>
                        </Col>
                        <Col lg="3">
                            <div className="mb-3 top-label">
                                {this.state.locked ? (
                                    <Form.Control
                                        type="text"
                                        name="county"
                                        value={this.state.data.county || ""}
                                        readOnly={true}
                                    />
                                ) : (
                                    <CountySelect
                                        value={this.state.data.county || ""}
                                        state={this.state.data.state}
                                        onChange={this.onCountyChange}
                                        placeholder=""
                                        name="county"
                                    />
                                )}
                                <Form.Label>COUNTY</Form.Label>
                            </div>
                        </Col>
                        <Col lg="2">
                            <div className="mb-3 top-label">
                                {this.state.locked ? (
                                    <Form.Control
                                        type="text"
                                        name="zipCode"
                                        value={this.state.data.zipCode || ""}
                                        readOnly={true}
                                    />
                                ) : (
                                    <NumberFormat
                                        format="#####-####"
                                        mask="_"
                                        className="form-control"
                                        value={this.state.data.zipCode || ""}
                                        allowEmptyFormatting
                                        onChange={(e) => this.onChange({
                                            target: { name: "zipCode", value: e.target.value }
                                        })}
                                    />
                                )}
                                <Form.Label>ZIP CODE</Form.Label>
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row>
                        <Col lg="4">
                            <div className="mb-3 top-label">
                                <Form.Control
                                    value={this.state.data.city || ""}
                                    type="text"
                                    name="city"
                                    onChange={this.onChange}
                                    readOnly={this.state.locked}
                                />
                                <Form.Label>CITY</Form.Label>
                            </div>
                        </Col>
                        <Col lg="3">
                            <div className="mb-3 top-label">
                                <Form.Control
                                    value={this.state.data.state || ""}
                                    type="text"
                                    name="state"
                                    onChange={this.onChange}
                                    readOnly={this.state.locked}
                                />
                                <Form.Label>STATE or PROVINCE</Form.Label>
                            </div>
                        </Col>
                        <Col lg="2">
                            <div className="mb-3 top-label">
                                <Form.Control
                                    value={this.state.data.zipCode || ""}
                                    type="text"
                                    name="zipCode"
                                    onChange={this.onChange}
                                    readOnly={this.state.locked}
                                />
                                <Form.Label>ZIP or POSTAL CODE</Form.Label>
                            </div>
                        </Col>
                    </Row>
                )}
            </>
        )
    }
}

export default Address;
